<template>
	<div class="custom-expression-editor d-flex flex-column">
		<div class="flex-grow-1">
			<!-- <div class="var-title">INDTAST BETINGELSE</div> -->
			<div class="expression-builder">
				<textarea ref="textarea" rows="1" :placeholder="$t('custom-expression-editor.expression-ph')" v-model="tempExpression" @input="onChange($event)"></textarea>
                <div v-show="hasError" class="small error-text" v-html="errorExplanation"></div>
				<!-- <div v-show="result" class="small">Resultat: <em>{{result === 'True' ? 'Sand' : '' }}</em></div> -->

				<!-- <custom-expression-display
					:expressionObject="expressionObject"
				/> -->

			</div>
			
		</div>
		<div>
			<div class="save-footer" :class="{ 'can-save': canSave, 'has-changs': hasChanges }">
				<div class="cancel" @click="$emit('close')">{{$t('custom-expression-editor.cancel')}}</div>
				<div class="save" @click="onSave">{{$t('custom-expression-editor.save')}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	// we should use a quill editor to make this more fun :)
	
	// import CustomExpressionDisplay from '@/components/CustomExpressionDisplay.vue'
	import debounce from 'lodash/debounce'
	import appHelper from "@/assets/js/appHelper.js";
	export default {
		props: {
			expression: {
				type: String
			},
			expressionObject: Object
		},
		data () {
			return {
				canSave: false,
				hasChanges: false,
				tempExpression: null,
                hasError: false,
                errorExplanation: null,
				result: null,
				onExpressionChangedDebounce: debounce(() => {
					this.onExpressionChanged(this.tempExpression)
				}, 500)
			}
		},
		computed: {
			
		},
		methods: {
			onChange(e){
				appHelper.resizeTextArea(e ? e.target : this.$refs.textarea)
				this.onExpressionChangedDebounce()
			},
			onExpressionChanged (exp) {
				this.$store.dispatch('testExpression', exp).then(result => {					
					if (exp === this.tempExpression) {
						this.canSave = result.valid
                        this.hasError = !result.valid

                        if (this.hasError) {
                            var errorExpl = ''
                            var errors = ''
                            result.tokens.forEach(t => {
                                errorExpl += t.tokenType === 'Invalid' ? '<b>' + t.value + "</b>" : t.value + " ";
                                if (t.tokenType === 'Invalid') errors += '<b>\'' + t.value + '\'</b>: ' + t.error + "<br/>"; 
                            })

                            this.errorExplanation = errorExpl + '<br/>' + errors;
                        }


						this.result = result.result
					}
				})
			},
			onSave () {
				if (!this.canSave) return
				this.$emit('expression-changed', this.tempExpression)
				this.$emit('close')
			}
		},
		components: {
			// CustomExpressionDisplay
		},
		watch: {
			expression: {
				immediate: true,
				handler (exp) {
					this.tempExpression = exp
				}
			}
		},
		mounted () {
			this.onChange()
		}
	}
</script>

<style lang="less">

	.custom-expression-editor {
		color: #3d464a;
		background: #fff;
		// min-width: 350px;
		height: 300px;
		max-height: 300px;
		padding: 0 !important;


		textarea {
        width: 100%;
        border: none;
        border-bottom: 1px solid var(--charcoal-50);
        resize: none;
        outline: none;
      }
	}
	
	.var-title {
		color: #DBDADA;
		font-family: 'Roboto', sans-serif;
		font-size: 14px;
		user-select: none;
		padding: 0 20px;
	}

	.expression-builder {
		position: relative;
		padding: 10px 20px 0 20px;
		min-height: 200px;
		max-height: 200px;
		overflow: auto;
		padding-top: 12px;
		input {
			padding: 0px;
			border: none;;
			border-bottom: 1px solid #f1f1f1;
			width: 100%;

			&:focus, &:active {
				// border: none;
				outline: none;
			}
		}

		.error-text {
			color: #cd4b3d;
		}

		// .valid-icon {
		// 	position: absolute;
		// 	right: 20px;
		// 	top: 8px;
		// 	width: 17px;
		// }
	
		
	}

</style>
